import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTask = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.375 6.875H3.125C3.2731 6.87504 3.41789 6.83124 3.54113 6.74911C3.66437 6.66698 3.76053 6.5502 3.8175 6.4135L5.1175 3.356C5.14719 3.28614 5.19739 3.22694 5.26145 3.18622C5.32551 3.14549 5.40042 3.12517 5.47627 3.12793C5.55213 3.1307 5.62536 3.15642 5.68629 3.20169C5.74722 3.24697 5.79297 3.30967 5.8175 3.3815L8.1845 10.744C8.20903 10.8158 8.25478 10.8785 8.31571 10.9238C8.37664 10.9691 8.44987 10.9948 8.52573 10.9976C8.60158 11.0003 8.67649 10.98 8.74055 10.9393C8.80461 10.8986 8.85481 10.8394 8.8845 10.7695L10.182 7.3365C10.239 7.1998 10.3351 7.08302 10.4584 7.00089C10.5816 6.91876 10.7264 6.87496 10.8745 6.875H12.6245",
		stroke: "#8C94AA",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgTask);
export default ForwardRef;
